<template>
  <div>
    <box-summary :currency="$store.getters.currency"/>
    <div class="box">
      <v-server-table
        ref="datatable"
        :url="api"
        :name="tableName"
        :columns="columns"
        :options="options"/>
    
      <receipt ref="receipt"/>
    </div>
  </div>
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import boxSummary from './box_summary.vue';
const TableName = 'VUETABLE_DISCOUNT';

export default {
    components: {
        boxSummary,
    },
    mixins: [receiptMixin],

    data: function() {
        var that = this;
        return {
            transaction: null,
            tableName: TableName,
            columns: [
                'settled_date',
                'receipt_number',
                'discount_name',
                'reason',
                'outlet_name',
                'payment_name',
                'amount',
                'total_cost',
                'total_discount',
                'after_discount',
                'cashier',
                'authorized_pic',
            ],
            options: {
                texts: {
                    title: 'Discount',
                    description: 'Discount details on transaction',
                },
                customFilters: ['outlet_id', 'since', 'until'],
                useReportFilter: true,
                columnsDropdown: true,
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },
                templates: {
                    amount: (h, row) => {
                        return numeral(parseFloat(row.amount)).format();
                    },
                    total_cost: (h, row) => {
                        return numeral(
                            parseFloat(row.total_cost || 0),
                        ).format();
                    },
                    total_discount: (h, row) => {
                        return numeral(parseFloat(row.total_discount)).format();
                    },
                    after_discount: (h, row) => {
                        return numeral(parseFloat(row.after_discount)).format();
                    },
                    receipt_number: (h, row) => {
                        return this.receiptNumberFormat(row);
                    },
                    settled_date: (h, row) => {
                        return this.receiptDateFormat(row.settled_date);
                    },
                },
                rowClassCallback: row => 'pointer',
                headings: {
                    amount: 'Sub Total',
                    total_cost: 'Total Cost',
                    payment_name: 'Payment',
                    discount_name: 'Discount Name',
                    outlet_name: 'Outlet',
                    receipt_number: 'Receipt No.',
                    authorized_pic: 'Authorized PIC',
                },
                rowClickCallback: row => {
                    this.showReceipt(row.id);
                },
                pdf_url: Laroute.route(
                    'franchise.report.discount.exportAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.discount.exportAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.discount.exportAsFile',
                    { type: 'XLSX' },
                ),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.report.discount.index');
        },
    },

    methods: {
        showReceipt(transaction_id) {
            this.$refs.receipt.$emit('show-receipt', transaction_id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/discount/index.vue